import './style/common.css';
import './style/main.less';
import Vue from 'vue';
import App from './App';
// import '@babel/polyfill'
import 'amfe-flexible/index.js'
// import './utils/rem.js';
import {router} from './router';
import * as utils from './utils';
import Directives from "./directive";
import {ImagePreview} from 'vant';

Vue.use(ImagePreview);
// import Vconsole from 'vconsole';
// const envMode = process.env.VUE_APP_CURRENTMODE;
// if (envMode != 'production') {
// let vConsole = new Vconsole();
// Vue.use(vConsole);
// }
Vue.use(Directives);

Vue.prototype.$utils = utils;

new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
